import { ReactNode } from 'react';
import { SnackbarViewProps } from './SnackbarContainer';

// Simple browser-compatible EventEmitter
class EventEmitter {
    private listeners: Map<string, Set<(...args: any[]) => void>> = new Map();

    emit(event: string, ...args: any[]) {
        const eventListeners = this.listeners.get(event);
        if (eventListeners) {
            eventListeners.forEach((listener) => {
                listener(...args);
            });
        }
    }

    addListener(event: string, listener: (...args: any[]) => void) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event)?.add(listener);
        return this;
    }

    removeListener(event: string, listener: (...args: any[]) => void) {
        const eventListeners = this.listeners.get(event);
        if (eventListeners) {
            eventListeners.delete(listener);
        }
        return this;
    }
}

class SnackbarManager extends EventEmitter {
    private props: SnackbarViewProps | undefined;

    private show(props: SnackbarViewProps) {
        this.props = props;
        this.emitChange();
        setTimeout(() => this.emit('info', undefined), props.timeout || 3000);
    }

    public warning = (message: ReactNode, timeout?: number) => this.show({ message, severity: 'warning', timeout });

    remove() {
        this.props = undefined;
        this.emitChange();
    }

    emitChange() {
        this.emit('info', this.props);
    }

    addChangeListener(callback: (props: SnackbarViewProps | undefined) => void) {
        this.addListener('info', callback);
    }
}

export default new SnackbarManager();
